import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function ArticleCards() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <h2 className="font-heading text-4xl md:text-5xl font-semibold text-foreground-950 tracking-tight">
            Fresh Guides
          </h2>
          <p className="mt-3 text-base text-foreground-500">
            Original sourcing content updated weekly — everything about Superbuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((article, idx) => (
            <article key={article.slug} className="bg-background-50 rounded-3xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all duration-300 flex flex-col">
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <Link
                  to={`/article/${article.slug}`}
                  className={`mt-5 block text-center w-full px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    idx === 0
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'border border-foreground-300 text-foreground-700 hover:bg-foreground-50 hover:border-foreground-400'
                  }`}
                >
                  Read Guide
                </Link>
                <p className="mt-3 text-xs text-foreground-400 text-center">
                  {article.date} · {article.readTime}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}